import { ELanguage, EProvince } from '@if/core/types'
import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface Props {
  correspondanceLanguageId: ELanguage
  applicantStateIso: EProvince | null
}

const LanguageProvinceIndicator = ({ correspondanceLanguageId, applicantStateIso }: Props) => {
  const { t } = useTranslation()

  return (
    <Typography
      variant="body1"
      component="div"
      sx={{ border: '2px solid', borderRadius: 2, p: 1, mb: 1, borderColor: 'error.main', float: 'right' }}
    >
      {t(`ELanguageAbbr.${correspondanceLanguageId}`, { ns: 'enum' })} | {applicantStateIso}
    </Typography>
  )
}

export default LanguageProvinceIndicator
